import styled, { keyframes } from "styled-components";
import { mobileAuthSideContainer, mobileAuthMainContainer } from "../../../styles/authShellMixins";

// Animações
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Container principal
export const MainContainer = styled.div`
  position: relative;
  display: flex;
  //flex-direction: column;
  //align-items: center;
  width: 100%;
  height: 100%;
  background: var(--app-bg-gradient);
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;

  ${mobileAuthMainContainer}
`;

export const SideContainer = styled.div`
  scrollbar-width: none; 
  overflow-y: auto; 
  overflow-x: hidden; 
  position: relative; 
  height: 100vh; 
  min-height: 100vh; 
  width: ${({ collapsed }) => (collapsed ? "calc(100% - 6vw)" : "calc(100% - 15vw)")};
  margin: auto;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out; 
  display: flex;
  flex-direction: column;
  align-items: center; /* Centraliza horizontalmente */
  justify-content: flex-start; /* Alinha no topo */

  &::-webkit-scrollbar {
    display: none; /* Remove scrollbar no Chrome/Safari */
  }

  ${mobileAuthSideContainer}
`;

// Wrapper do conteúdo
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0 auto;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: 1rem 0.75rem 2rem;
  }
`;

// Padrão de fundo decorativo
export const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
  background-image: 
    radial-gradient(circle at 25% 25%, var(--accent-secondary) 2px, transparent 2px),
    radial-gradient(circle at 75% 75%, var(--accent) 1px, transparent 1px);
  background-size: 100px 100px, 60px 60px;
  z-index: 0;
`;

// Seção do cabeçalho
export const HeaderSection = styled.header`
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
`;

// Título principal
export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 2rem 0;
  text-shadow: 0 4px 20px color-mix(in srgb, var(--accent-secondary) 30%, transparent);
  text-align: center;
  animation: ${fadeInUp} 0.6s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: both;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// Subtítulo
export const Subtitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--text-heading);
  margin: 0;
  letter-spacing: 0.05em;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const TabsRow = styled.div`
  display: flex;
  gap: 0.8rem;
  margin: 0 0 1rem 0;
`;

export const TabButton = styled.button`
  background: ${({ active }) =>
    active ? "var(--accent-soft)" : "var(--surface-glass)"};
  border: 2px solid
    ${({ active }) => (active ? "var(--accent)" : "var(--border-default)")};
  color: ${({ active }) => (active ? "var(--accent-secondary)" : "var(--text-primary)")};
  border-radius: 12px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--accent);
    transform: translateY(-1px);
  }
`;


// Grid de botões
export const ButtonGrid = styled.div`
  position: fixed;
  bottom: 90vh;   /* 5% da altura da tela */
  right: 4vw;    /* 3% da largura da tela */
  display: flex;
  justify-content: flex-end;
  width: auto;
  //z-index: 1000;
`;



// Botão de ação
export const ActionButton = styled.button`
  position: relative;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  border-radius: 20px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 20vw;
  height: 26vh;
  overflow: hidden;
  
  /* Pseudo-elemento para o gradiente de fundo */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--accent-secondary-soft) 0%, var(--accent-soft) 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 20px;
    z-index: 1;
    box-shadow: inset 0 0 20px var(--accent-soft);
  }
  
  /* Pseudo-elemento para a sombra externa que se move junto */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: transparent;
    box-shadow: 0 12px 32px var(--accent-soft);
    opacity: 0;
    transition: all 0.4s ease;
    z-index: -1;
    pointer-events: none;
  }
  
  &:hover::before {
    opacity: 1;
  }
  
  &:hover::after {
    opacity: 1;
    transform: translateY(-8px); /* Sombra se move junto com o botão */
  }
  
  &:hover {
    transform: translateY(-8px);
    border-color: var(--accent);
    box-shadow: inset 0 1px 0 var(--surface-glass-strong);
  }
  
  &:active {
    transform: translateY(-4px);
  }
  
  &:active::after {
    transform: translateY(-4px);
  }
  
  @media (max-width: 768px) {
    width: 20vw;
    height: 24vh;
    padding: 1.8rem;
  }
  
  @media (max-width: 480px) {
    width: 80vw;
    height: 20vh;
    padding: 1.5rem;
  }
  
  > * {
    position: relative;
    z-index: 2;
  }
`;

// Descrição do botão
export const ButtonDescription = styled.p`
  font-size: 0.8rem;
  color: var(--text-heading);
  margin: 0;
  line-height: 1.4;
  opacity: 0.8;
  transition: opacity 0.3s ease;

  ${ActionButton}:hover & {
    opacity: 1;
    color: var(--text-heading);
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const StyledButton = styled.button`
  background: ${props => props.secondary 
    ? 'var(--input-bg)' 
    : 'var(--accent-secondary-soft)'};
  border: 2px solid ${props => props.secondary 
    ? 'var(--border-subtle)' 
    : 'var(--border-default)'};
  border-radius: 16px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--text-heading)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;
  marginLeft: "auto"

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      ${props => props.secondary 
        ? 'var(--input-bg) 0%, var(--surface-glass) 100%' 
        : 'var(--accent-secondary-soft) 0%, var(--accent-soft) 100%'}
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 14px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    background: transparent;
    box-shadow: ${props => props.secondary 
      ? 'var(--shadow-sm)' 
      : '0 6px 15px var(--accent-soft)'};
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-3px);
    border-color: ${props => props.secondary 
      ? 'var(--text-muted)' 
      : 'var(--accent)'};
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }

    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;

export const SmallActionButton = styled(ActionButton)`
  flex-direction: row;        
  align-items: center;        
  justify-content: center; 
  gap: 0.5rem;                
  padding: 0.8rem 1rem;
  width: 14vw;    
  height: 6vh;        

  @media (max-width: 768px) {
    padding: 0.6rem 0.8rem;
    gap: 0.4rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.6rem;
    gap: 0.3rem;
  }
`;

// Ícone do botão
export const ButtonIcon = styled.div`
  font-size: 1.2rem;
  display: flex;              /* 🔥 garante centralização */
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 4px 8px var(--accent-soft));

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

// Texto do botão
export const ButtonText = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: var(--accent-secondary);
  margin: 0;                  /* 🔥 remove margem que desalinhava */
  line-height: 1.3;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const SearchSection = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  position: relative;
  animation: ${fadeInUp} 0.6s ease-out;
  animation-delay: 0.3s;
  animation-fill-mode: both;
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1%;
  margin: 1%;
`;

export const SearchBox = styled.div`
  min-height: 8vh;
  width: 38vw;
  display: flex;
  backdrop-filter: blur(20px);
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
  background: var(--input-bg);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--accent);
    box-shadow: 0 8px 32px var(--accent-soft);
  }

  &:focus-within {
    border-color: var(--accent);
    box-shadow: 0 8px 32px var(--accent-soft);
  }

  @media (max-width: 768px) {
    width: 90%;
    flex-direction: column;
    min-height: auto;
  }

  @media (max-width: 480px) {
    width: 95%;
  }
`;

export const SelectStyled = styled.select`
  flex: 0 0 auto;
  outline: none;
  padding: 0 1rem;
  font-size: 0.9rem;
  background: transparent;
  color: var(--accent-secondary);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  border: none;
  border-right: 1px solid var(--border-subtle);
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23dbfb8e'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.7rem center;
  background-size: 1rem;
  padding-right: 2.5rem;

  option {
    background: var(--surface-1);
    color: var(--accent-secondary);
    padding: 0.5rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--border-subtle);
    text-align: center;
    padding: 1rem;
    background-position: right 1rem center;
  }

  @media (max-width: 480px) {
    padding: 0.8rem;
    font-size: 0.8rem;
    min-width: auto;
  }
`;

export const InputStyled = styled.input`
  flex: 1;
  padding: 0 1.5rem;
  border: none;
  outline: none;
  font-size: 1rem;
  background: transparent;
  color: var(--accent-secondary);
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.8rem;
    font-size: 0.9rem;
  }
`;

export const AreaListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  margin: 0;
  overflow: visible;
  box-sizing: border-box;
`;


export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;   /* 🔥 mesma altura vertical */
  width: 100%;
  margin: 0.5% 0;
`;

export const ButtonContainerLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.5rem;
`;

export const ButtonContainerRight = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const FirmsList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
`;

export const FirmsCard = styled.div`
  background: var(--surface-glass);
  border: 1px solid var(--border-subtle);
  border-radius: 16px;
  padding: 1rem;
  backdrop-filter: blur(12px);
`;

export const FirmsTitle = styled.h3`
  color: var(--accent-secondary);
  margin: 0 0 0.7rem 0;
  font-size: 1rem;
`;

export const FirmsMeta = styled.p`
  margin: 0.2rem 0;
  color: var(--text-primary);
  font-size: 0.86rem;
`;

export const FirmsActions = styled.div`
  margin-top: 0.9rem;
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
`;

export const FirmsEmpty = styled.div`
  color: var(--text-heading);
  text-align: center;
  width: 100%;
  padding: 1.5rem 0;
`;
